module.exports = __webpack_public_path__ + "static/media/Wonder women 2.32fa4988.jpg";